import React from "react";
import {
  Activity,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  AlignLeft,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  Award,
  Ban,
  BarChart3,
  Bell,
  BellOff,
  Book,
  BookMarked,
  BookOpen,
  BookX,
  Building2,
  Calendar,
  Camera,
  Check,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  ClipboardList,
  Clock,
  Clock3,
  CloudOff,
  CloudUpload,
  Copy,
  CreditCard,
  Crown,
  DollarSign,
  Download,
  Edit,
  Edit2,
  Edit3,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileCheck,
  FileText,
  Film,
  Filter,
  FlaskConical,
  Globe,
  GraduationCap,
  Grid3X3,
  Hash,
  HelpCircle,
  History,
  Image,
  ImagePlus,
  IndianRupee,
  Info,
  KeyRound,
  Layers,
  LayoutDashboard,
  Lightbulb,
  LineChart,
  Link,
  Link2,
  List,
  Loader,
  Loader2,
  Lock,
  LockKeyhole,
  LogOut,
  Mail,
  MapPin,
  Maximize,
  Megaphone,
  Menu,
  MessageSquare,
  Minimize,
  Minus,
  MoreHorizontal,
  MousePointerClick,
  Move,
  Package,
  Pause,
  Pencil,
  Percent,
  Phone,
  PictureInPicture2,
  Play,
  PlayCircle,
  Plus,
  PlusCircle,
  Quote,
  Radio,
  Receipt,
  RefreshCw,
  RotateCcw,
  Save,
  School,
  ScrollText,
  Search,
  SearchX,
  Send,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShoppingCart,
  SkipBack,
  SkipForward,
  Smartphone,
  Sparkles,
  Square,
  Star,
  StarOff,
  Tag,
  Target,
  TestTube,
  Ticket,
  TimerReset,
  ToggleLeft,
  Trash2,
  TrendingDown,
  TrendingUp,
  Type,
  Undo,
  Unlock,
  Upload,
  User,
  UserCheck,
  UserCircle,
  UserPlus,
  UserX,
  Users,
  Video,
  Volume2,
  VolumeX,
  Wifi,
  WifiOff,
  X,
  XCircle,
  Zap,
  createLucideIcon,
  type LucideIcon,
  type LucideProps,
} from "lucide-react";

// Brand icons were removed in lucide v1; the two we use are kept locally with their former lucide path data
const Linkedin = createLucideIcon("linkedin", [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f",
    },
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
]);

const Youtube = createLucideIcon("youtube", [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4",
    },
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }],
]);

const ICONS = {
  Activity,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  AlignLeft,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  Award,
  Ban,
  BarChart3,
  Bell,
  BellOff,
  Book,
  BookMarked,
  BookOpen,
  BookX,
  Building2,
  Calendar,
  Camera,
  Check,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  ClipboardList,
  Clock,
  Clock3,
  CloudOff,
  CloudUpload,
  Copy,
  CreditCard,
  Crown,
  DollarSign,
  Download,
  Edit,
  Edit2,
  Edit3,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileCheck,
  FileText,
  Film,
  Filter,
  FlaskConical,
  Globe,
  GraduationCap,
  Grid3X3,
  Hash,
  HelpCircle,
  History,
  Image,
  ImagePlus,
  IndianRupee,
  Info,
  KeyRound,
  Layers,
  LayoutDashboard,
  Lightbulb,
  LineChart,
  Link,
  Link2,
  Linkedin,
  List,
  Loader,
  Loader2,
  Lock,
  LockKeyhole,
  LogOut,
  Mail,
  MapPin,
  Maximize,
  Megaphone,
  Menu,
  MessageSquare,
  Minimize,
  Minus,
  MoreHorizontal,
  MousePointerClick,
  Move,
  Package,
  Pause,
  Pencil,
  Percent,
  Phone,
  PictureInPicture2,
  Play,
  PlayCircle,
  Plus,
  PlusCircle,
  Quote,
  Radio,
  Receipt,
  RefreshCw,
  RotateCcw,
  Save,
  School,
  ScrollText,
  Search,
  SearchX,
  Send,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShoppingCart,
  SkipBack,
  SkipForward,
  Smartphone,
  Sparkles,
  Square,
  Star,
  StarOff,
  Tag,
  Target,
  TestTube,
  Ticket,
  TimerReset,
  ToggleLeft,
  Trash2,
  TrendingDown,
  TrendingUp,
  Type,
  Undo,
  Unlock,
  Upload,
  User,
  UserCheck,
  UserCircle,
  UserPlus,
  UserX,
  Users,
  Video,
  Volume2,
  VolumeX,
  Wifi,
  WifiOff,
  X,
  XCircle,
  Youtube,
  Zap,
} satisfies Record<string, LucideIcon>;

/** Names registered in ICONS; an unknown name is a type error. */
export type IconName = keyof typeof ICONS;

interface IconProps extends Omit<LucideProps, "size"> {
  name: IconName;
  size?: number;
  color?: string;
  className?: string;
  strokeWidth?: number;
}

function Icon({
  name,
  size = 24,
  color = "currentColor",
  className = "",
  strokeWidth = 2,
  ...props
}: IconProps) {
  // Fallback for names that arrive untyped at runtime (e.g. from API data cast to IconName).
  const IconComponent = ICONS[name] as React.ComponentType<LucideProps> | undefined;

  if (!IconComponent) {
    return (
      <HelpCircle
        size={size}
        color="gray"
        strokeWidth={strokeWidth}
        className={className}
        {...props}
      />
    );
  }

  return (
    <IconComponent
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      {...props}
    />
  );
}

export default Icon;
